export enum ProfessionalTypeEnum {
	psychologist = 'psychologist',
	coach = 'coach',
	psychoanalyst = 'psychoanalyst',
	therapist = 'therapist',
	nutritionist = 'nutritionist',
	psychiatrist = 'psychiatrist',
	others = 'others',
}
